import { cleanTitle } from "../../../utils";
import { ChevronRight } from 'lucide-react';
import { useState } from "react";
import BookDetailsPopUp from "../../../components/BookDetailsPopUp.jsx";
import Loader from "../../../components/loader.jsx";  

function SuggestionsResults(props) {
    const [selectedBookId, setSelectedBookId] = useState(null);
    const [showBookDetail, setShowBookDetail] = useState(false);
    function renderBooksCB(book) {

        function handleBookClickACB() {
            console.log("Clicked book with ID:", book.bookId);
            setSelectedBookId(book.bookId);
            props.onOpenDetails(book.bookId);
            setShowBookDetail(true);
        }
    
        const authorString = book.author.map(author => author.name).join(", ");
        
        return (
            <div
                key={book.bookId}
                onClick={handleBookClickACB}
                className="flex gap-4 p-4 bg-white rounded-lg !border border-amber-200 hover:border-amber-300 hover:shadow-md transition-all cursor-pointer"
                >
                <img
                    src={book.imageUrl}
                    alt={cleanTitle(book.title, book.author)}
                    className="w-16 h-24 object-cover rounded"
                />
                <div className="flex-1">
                    <h4 className="text-amber-900 mb-1">{cleanTitle(book.title, book.author)}</h4>
                    <p className="text-amber-600 mb-2">{authorString}</p>
                </div>
                <div className="flex items-center">
                    <ChevronRight className="w-5 h-5 text-amber-400" />
                </div>
            </div>
        );
    }
    function renderLoders(){
        const temp = Array(5).fill(null);
        return temp.map((_, idx) => (
            <div 
            key={idx}
            className="flex gap-4 p-4 bg-white rounded-lg !border border-amber-200 hover:border-amber-300 transition-all cursor-pointer"
            >
                <Loader/>
            </div>
        ));
    }

    return (
        <div>
            <div className="space-y-2 max-h-96 overflow-y-auto">
                {props.status === "fulfilled" && (
                    props.searchResults && props.searchResults.length > 0 ? (
                        props.searchResults.map((book) => renderBooksCB(book))
                    ) : 
                    
                    (<h3 className="text-amber-900 mb-4">No Books found. Try using Title or Author for the best results</h3>))
            
                }
                {props.status === "pending" && renderLoders()}
                {props.status === "rejected" && <h3 className="text-amber-900 mb-4">Error: {props.error}</h3>}
            </div>
                        <BookDetailsPopUp
                        show={showBookDetail}
                        setShow={setShowBookDetail}
                        book={props.searchResultId}
                        suggested={props.checkIfSuggested(selectedBookId)}
                        statusId={props.statusId}
                        errorId={props.errorId}
                        addSuggestion={(book) => props.addSuggestion(book)}
                        onClose={() => props.onCloseDetails()}
                        />
        </div>
    );
}
export default SuggestionsResults;
